module.exports = __webpack_public_path__ + "h5/img/add_logo.84d1dcc6.png";